<template>
  <div>    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Audience:
      </h1> 
      <h1>
        Total Audience: {{ Number(audienceCount || 0).toLocaleString() }}
      </h1>
    </section>

    <!-- Main content -->
    <section class="content" v-show="showTable">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div >
              <table class="table table-striped table-apps">
                <thead>
                  <th>Account Id</th>
                </thead>
                <tbody>
                  <tr v-if="hasRun && audienceData.length === 0 && !loading"><td colspan="13" align="center">No Result found.</td></tr>
                  <tr v-show="audienceData.length" v-for="(audience, index) in audienceData" :key="index">
                    <td>{{audience.accountId}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>  
      </div>       
    </section>
  </div>  
  
</template>
<script>
export default {
  name: 'audienceTable',
  props: {
    audienceData: { type: Array, default: () => [] },
    audienceCount: { type: [Number, String], default: null },
    showTable: { type: Boolean, default: true },
    // Show the "No Result found." row only after a count has actually run (other screens keep the old behaviour).
    hasRun: { type: Boolean, default: true }
  },
  async mounted () {
    // await this.getAllCustomer()
    this.loading = false
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// table.vue?6f616bd2